/* Sneak shared money formatter.
   Consolidates the duplicate inline formatters from qty-breaks.liquid,
   metafield-bundle-picker.liquid and product-upsell.liquid. Output for EUR is
   character-identical to all three originals: "49,90€", "50€" (",00" stripped).
   SEK keeps product-upsell's " kr" suffix; any other currency appends its code.
   NOTE: bundle-deals.js / bundle-tiers.js intentionally keep their own locale
   money() derived from the theme's money filter sample — different format. */
(function () {
  if (window.SneakMoney) return;
  function format(cents, currencyCode) {
    var amount = (cents / 100).toFixed(2);
    var formatted;
    if (!currencyCode || currencyCode === 'EUR') {
      formatted = amount.replace('.', ',') + '€';
    } else if (currencyCode === 'SEK') {
      formatted = amount.replace('.', ',') + ' kr';
    } else {
      formatted = amount + ' ' + currencyCode;
    }
    // Strip ",00" / ".00" — after the decimal-comma conversion the string holds
    // exactly one separator, so this equals the originals' trailing-only strips.
    return formatted.replace(/,00/g, '').replace(/\.00/g, '');
  }
  window.SneakMoney = { format: format };
})();
